export default {
  FIND_ALL_INSTANCES_REQUEST: 'FIND_ALL_INSTANCES_REQUEST',
  FIND_ALL_INSTANCES_SUCCESS: 'FIND_ALL_INSTANCES_SUCCESS',
  FIND_ALL_INSTANCES_ERROR: 'FIND_ALL_INSTANCES_ERROR',

  CREATE_INSTANCE_SUCCESS: 'CREATE_INSTANCE_SUCCESS',
  UPDATE_INSTANCE_SUCCESS: 'UPDATE_INSTANCE_SUCCESS',
  REMOVE_INSTANCE_SUCCESS: 'REMOVE_INSTANCE_SUCCESS'
};
